import { render } from "./PackageOrderGeneratorDetailsSection.vue?vue&type=template&id=ada35926&scoped=true"
import script from "./PackageOrderGeneratorDetailsSection.vue?vue&type=script&lang=js"
export * from "./PackageOrderGeneratorDetailsSection.vue?vue&type=script&lang=js"

import "./PackageOrderGeneratorDetailsSection.vue?vue&type=style&index=0&id=ada35926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada35926"]])

export default __exports__